import React, { useState } from 'react';
import { IconButton, Tooltip, Fab } from '@mui/material';
import { Help as HelpIcon } from '@mui/icons-material';
import HelpSystem from './HelpSystem';
import { theme, commonStyles } from '../../styles/theme';

const HelpButton = ({ userMode = 'simple', variant = 'fab' }) => {
  const [helpOpen, setHelpOpen] = useState(false);

  if (variant === 'fab') {
    return (
      <>
        <Tooltip title="Open Help System">
          <Fab
            color="primary"
            onClick={() => setHelpOpen(true)}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              bgcolor: theme.colors.primary,
              '&:hover': {
                bgcolor: '#991b1b',
              },
              zIndex: 1000
            }}
          >
            <HelpIcon />
          </Fab>
        </Tooltip>
        <HelpSystem 
          open={helpOpen} 
          onClose={() => setHelpOpen(false)} 
          userMode={userMode}
        />
      </>
    );
  }

  return (
    <>
      <Tooltip title="Open Help System">
        <IconButton
          onClick={() => setHelpOpen(true)}
          sx={{
            color: theme.colors.primary,
            '&:hover': {
              bgcolor: 'rgba(39, 48, 63, 0.4)',
            }
          }}
        >
          <HelpIcon />
        </IconButton>
      </Tooltip>
      <HelpSystem 
        open={helpOpen} 
        onClose={() => setHelpOpen(false)} 
        userMode={userMode}
      />
    </>
  );
};

export default HelpButton;
